import { createRouter, createWebHashHistory, } from "vue-router"
import weixin from "@/common/weixin"
import tool from "@/common/tool"
import config from "@/common/config"
import { adminRouterBefore, liveRouterBefore,reportAdminRouterBefore, commonRouterBefore } from './routerBefore'
const commonRoutes = [
  {
    path: '/:pathMatch(.*)*',
    name: 'page404',
    component: () => import(/* webpackChunkName "page404" */ '@/components/help/page404.vue')
  },
  {
    path: "/endLive",
    meta: { title: "直播结束提醒" },
    name: "endLive",
    component: () => import(/* webpackChunkName: "endLive", webpackPrefetch: true */ "@/components/pages/user/endLive.vue")
  },
  {
    path: '/chatRoom',
    name: 'chatRoom',
    meta: { title: "群聊" },
    beforeEnter: adminRouterBefore,
    component: () => import(/* webpackChunkName "chatRoom" */ '@/components/pages/chat/chatRoom.vue')
  },
  {
    path: '/',
    name: 'MeetList',
    meta: { title: "会议列表" },
    beforeEnter: adminRouterBefore,
    component: () => import(/* webpackChunkName "MeetList" */ '@/components/pages/MeetList.vue')
  },
  {
    path: '/MeetList',
    name: 'MeetList',
    meta: { title: "会议列表" },
    beforeEnter: adminRouterBefore,
    component: () => import(/* webpackChunkName "MeetList" */ '@/components/pages/MeetList.vue')
  },
  {
    path: '/DoctorList',
    name: 'DoctorList',
    meta: { title: "医生列表" },
    beforeEnter: adminRouterBefore,
    component: () => import(/* webpackChunkName "DoctorList" */ '@/components/pages/DoctorList.vue')
  },
  {
    path: '/MeetMaterials',
    name: 'MeetMaterials',
    meta: { title: "会后资料" },
    beforeEnter: adminRouterBefore,
    component: () => import(/* webpackChunkName "MeetMaterials" */ '@/components/pages/MeetMaterials.vue')
  },
  {
    path: '/EditDoctorProfile',
    name: 'EditDoctorProfile',
    meta: { title: "完善医生信息" },
    beforeEnter: adminRouterBefore,
    component: () => import(/* webpackChunkName "EditDoctorProfile" */ '@/components/pages/EditDoctorProfile.vue')
  },
  {
    path: '/LaborManagement',
    name: 'LaborManagement',
    meta: { title: "劳务管理" },
    beforeEnter: adminRouterBefore,
    component: () => import(/* webpackChunkName "LaborManagement" */ '@/components/pages/LaborManagement.vue')
  },
  {
    path: '/CreateMeet',
    name: 'CreateMeet',
    meta: { title: "创建会议" },
    beforeEnter: adminRouterBefore,
    component: () => import(/* webpackChunkName "CreateMeet" */ '@/components/pages/CreateMeet.vue')
  },
  {
    path: '/DoctorDetail',
    name: 'DoctorDetail',
    meta: { title: "医生详情" },
    beforeEnter: adminRouterBefore,
    component: () => import(/* webpackChunkName "DoctorDetail" */ '@/components/pages/DoctorDetail.vue')
  },
  {
    path: '/PaymentInfo',
    name: 'PaymentInfo',
    meta: { title: "完善付款信息" },
    beforeEnter: adminRouterBefore,
    component: () => import(/* webpackChunkName "PaymentInfo" */ '@/components/pages/PaymentInfo.vue')
  },
  {
    path: '/reportApplyAudit',
    name: 'reportApplyAudit',
    meta: { title: "报名申请审核" },
    beforeEnter: reportAdminRouterBefore,
    component: () => import(/* webpackChunkName "reportApplyAudit" */ '@/components/pages/user/reportApplyAudit.vue')
  },
  {
    path: '/MeetDetail',
    meta: { title: "会议详情" },
    name: 'MeetDetail',
    component: () => import(/* webpackChunkName "MeetDetail" */ '@/components/pages/meet/MeetDetail.vue')
  },
]

const liveRoutes = [
  {
    path: "/sign",
    meta: { title: "签到" },
    name: "sign",
    component: () => import(/* webpackChunkName: "sign", webpackPrefetch: true */ "@/components/pages/user/signIn.vue")
  },
  {
    path: "/live",
    beforeEnter: liveRouterBefore,
    name: "live",
    component: () => import(/* webpackChunkName: "live", webpackPrefetch: true */ "@/components/pages/live/live.vue")
  },
]

const ignoreRoutes = [
  {
    path: "/login",
    meta: { title: "登录" },
    name: "login",
    component: () => import(/* webpackChunkName "login" */ '@/components/pages/user/login.vue')
  },
  {
    path: "/addMeetCreater",
    meta: { title: "会议创建人注册" },
    name: "addMeetCreater",
    component: () => import(/* webpackChunkName "addMeetCreater" */ '@/components/pages/user/addMeetCreater.vue')
  },
  {
    path: "/patchMeetCreater",
    meta: { title: "会议创建人修改" },
    name: "patchMeetCreater",
    component: () => import(/* webpackChunkName "patchMeetCreater" */ '@/components/pages/user/patchMeetCreater.vue')
  },
  {
    path: "/changeMeetCreater",
    meta: { title: "会议创建人变更" },
    name: "changeMeetCreater",
    component: () => import(/* webpackChunkName "changeMeetCreater" */ '@/components/pages/user/changeMeetCreater.vue')
  },
  {
    path: "/changeDoctorManage",
    meta: { title: "专家对接人变更" },
    name: "changeDoctorManage",
    component: () => import(/* webpackChunkName "changeDoctorManage" */ '@/components/pages/user/changeDoctorManage.vue')
  },
  {
    path: "/navigation",
    meta: { title: "报名系统" },
    name: "navigation",
    component: () => import(/* webpackChunkName "navigation" */ '@/components/pages/user/reportNavigation.vue')
  },
  {
    path: "/jump",
    name: "jump",
    component: () => import(/* webpackChunkName: "jump", webpackPrefetch: true */ "@/components/main/jump.vue")
  },
  {
    path: "/agreement",
    meta: { title: "劳务协议签署" },
    name: "agreement",
    component: () => import(/* webpackChunkName: "agreement", webpackPrefetch: true */ "@/components/pages/agreement/index.vue")
  },
]
const routes = [].concat(commonRoutes, liveRoutes, ignoreRoutes);
// const routes =  []
const router = createRouter({
  history: createWebHashHistory(),
  routes
});

const ignorePages = ignoreRoutes.map(item => item.name) // 不需要验证的页面
router.beforeEach((to, from, next) => {
  tool.saveVersion()
  if (ignorePages.includes(to.name)) { next(); return; }
  // weixin.init()
  // document.title = config.title
  // if (to.meta.title !== undefined) {
  //   document.title = !to.meta.title ? config.title : `${config.title}-${to.meta.title}`
  // }

  tool.isLocal() ? development(to, from, next) : produce(to, from, next);
})
async function development(to, from, next) {
  tool.setCookie('openid', 'o2N2L557kfqbx_41LCHlC3ekbXN8')
  inSystem(to, from, next)
}
async function produce(to, from, next) {
  const livePages = liveRoutes.map(item => item.name) // 直播页面
  if (livePages.includes(to.name)) { 
    weixin.init()
    let openid = tool.getCookie("openid") || "";
    if (!openid) {
      next({ name: "jump", path: "/jump", query: { path: to.path, ...to.query } })
      return;
    }
  }
  inSystem(to, from, next)
}
async function inSystem(to, from, next) {
  next()
}
export default router;
